import { useMemo } from "react";
import { TAB_ID_SET } from "../config/constants";
import useBasicFormData from "../store/useBasicFormData";

export default function useReserveTimeInfo() {
  const { basicFormData } = useBasicFormData();

  return useMemo(() => {
    if (basicFormData.storeTimeStepData) {
      const {
        reserveType: reserveTabIndex,
        arriveStoreTimeData,
        arriveStoreTimeByDateTab,
      } = basicFormData.storeTimeStepData;
      // 选择门店维度
      if (reserveTabIndex === TAB_ID_SET.STORE_TAB) {
        return arriveStoreTimeData;
      }

      // 日期维度
      if (reserveTabIndex === TAB_ID_SET.DATE_TAB) {
        return arriveStoreTimeByDateTab;
      }
    }
    return null;
  }, [basicFormData.storeTimeStepData]);
}
